import { LitElement, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html';
import { translate } from '../fit-polyglot/fit-polyglot-behavior';
import { TimerBehavior } from './fit-timer-behavior';

import styles from './fit-countdown.css';

function pluralize(key, count) {
  const options = {
    smart_count: count || 0,
    count: `<span class="countdown__number">${count || 0}</span>`,
  };
  return unsafeHTML(translate(key, options));
}

class FitCountdown extends TimerBehavior(LitElement) {
  static get is() { return 'fit-countdown'; }

  static get styles() { return styles; }

  render() {
    return html`
      ${this.timeRemaining ? html`
        <div class="countdown countdown--time-remaining">
          <h5 class="countdown__title">${translate(this.labels.TimeRemaining.Title)}&nbsp;${this.timeRemaining.days ? html`<span>${pluralize(this.labels.TimeRemaining.Days, this.timeRemaining.days)}</span>` : ''}
          </h5>
          <div class="countdown__timers">
            ${this.timeRemaining.days || this.timeRemaining.hours ? html`<span class="countdown__timer countdown__timer--hours">${pluralize(this.labels.TimeRemaining.Hours, this.timeRemaining.hours)}</span>` : ''}
            ${this.timeRemaining.days || this.timeRemaining.hours || this.timeRemaining.minutes ? html`<span class="countdown__timer countdown__timer--minutes">${pluralize(this.labels.TimeRemaining.Minutes, this.timeRemaining.minutes)}</span>` : ''}
            ${this.timeRemaining.days || this.timeRemaining.hours || this.timeRemaining.minutes ? html`<span class="countdown__timer countdown__timer--seconds">${pluralize(this.labels.TimeRemaining.Seconds, this.timeRemaining.seconds)}</span>` : ''}
          </div>
        </div>` : ''}

      ${this.timeUntil ? html`
        <div class="countdown countdown--time-until">
          <h5 class="countdown__title">${translate(this.labels.TimeUntil.Title)}</h5>
          <div class="countdown__timers">
            ${this.timeUntil.days ? html`<span class="countdown__timer countdown__time--days">${pluralize(this.labels.TimeUntil.Days, this.timeUntil.days)}</span>` : ''}
            ${!this.timeUntil.days && this.timeUntil.hours ? html`<span class="countdown__timer countdown__timer--hours">${pluralize(this.labels.TimeUntil.Hours, this.timeUntil.hours)}</span>` : ''}
            ${!this.timeUntil.days && this.timeUntil.minutes ? html`<span class="countdown__timer countdown__timer--minutes">${pluralize(this.labels.TimeUntil.Minutes, this.timeUntil.minutes)}</span>` : ''}
            ${!this.timeUntil.hours ? html`<span class="countdown__timer countdown__timer--seconds">${pluralize(this.labels.TimeUntil.Seconds, this.timeUntil.seconds)}</span>` : ''}
          </div>
        </div>` : ''}
       ${!this.timeUntil && !this.timeRemaining ? html`
        <div class="countdown countdown--expired">
          <h5 class="countdown__title">${translate(this.labels.Expired.Title)}</h5>
        </div>` : ''}
      `;
  }

  static get properties() {
    return {
      labels: {
        type: Object,
      },
    };
  }
}

customElements.define(FitCountdown.is, FitCountdown);
